module.exports = __webpack_public_path__ + "static/media/akar-icons_chevron-up.acc2e84e.svg";